import { Module } from 'cerebral'
import mediaClicked from './chains/mediaClicked'
import beginDragMedia from './chains/beginDragMedia'
import endDragMedia from './chains/endDragMedia'
import selectAllFilesInState from './chains/selectAllFilesInState'
import deselectAllFiles from './chains/deselectAllFiles'
import saveUploadingFilesToState from './chains/saveUploadingFilesToState'
import onUploadProgress from './chains/onUploadProgress'
import enterMedia from './chains/enterMedia'
import leaveMedia from './chains/leaveMedia'
import onDragBeginHook from './chains/onDragBeginHook'
import onOpenTagMenu from './chains/onOpenTagMenu'
import onOpenFilterMenu from './chains/onOpenFilterMenu'
import saveMetaField from './chains/saveMetaField'
import onShowDetailedView from './chains/onShowDetailedView'
import onCloseDetailedView from './chains/onCloseDetailedView'
import modifierKeyDown from './chains/modifierKeyDown'
import modifierKeyUp from './chains/modifierKeyUp'
import onEscapeDown from './chains/onEscapeDown'
import toggleEditableTags from './chains/toggleEditableTags'
import toggleSharedTagsView from './chains/toggleSharedTagsView'
import searchMedia from './chains/searchMedia'
import onFilesDropped from './chains/onFilesDropped'
import onUploadNext from './chains/onUploadNext'
import onDeleteSelectedFiles from './chains/onDeleteSelectedFiles'
import askDeleteFiles from './chains/askDeleteFiles'
import onScaleDetailedImage from './chains/onScaleDetailedImage'
import onDeleteFileInDetailedView from './chains/onDeleteFileInDetailedView'
import onOverridePreview from './chains/onOverridePreview'
import onUploadPreviewProgress from './chains/onUploadPreviewProgress'
import onMouseUp from './chains/onMouseUp'
import changeSortType from './chains/changeSortType'
import showUploadPanel from './chains/showUploadPanel'
import deleteFromUploadQueue from './chains/deleteFromUploadQueue'
import { loadMediaWithFetchId } from './chains/loadMediaFiles'
import setActiveGroup from './chains/setActiveGroup'
import changeFormValue from './chains/changeFormValue'
import togglePillClicked from './chains/togglePillClicked'
import setCurrentDetailedFile from './chains/setCurrentDetailedFile'
import onBlurPill from './chains/onBlurPill'
import onFocusPill from './chains/onFocusPill'
import showFileContextMenu from './chains/showFileContextMenu'
import hideFileContextMenu from './chains/hideFileContextMenu'
import refetchMetadata from './chains/refetchMetadata'

export default Module(({ name, path, controller }) => {
  return {
    state: {
      tags: {
        editMode: false,
        showShared: false,
        isLoading: false,
        open: false
      },
      latestSearchCriteria: null,
      showDetail: false,
      loadingFiles: false,
      uploading: {},
      files: {},
      selectedFiles: [],
      sortType: 'LATEST',
      filesToDelete: [],
      canDropMedia: false,
      keyboard: {
        keys: {}
      },
      isUploading: false,
      isLoading: false,
      contextMenu: {},
      filter: {
        fileTypes: {},
        open: false,
        active: false,
        repaint: false
      }
    },
    signals: {
      mediaClicked,
      beginDragMedia,
      changeSortType,
      endDragMedia,
      selectAllFilesInState,
      deselectAllFiles,
      saveUploadingFilesToState,
      onUploadProgress,
      enterMedia,
      leaveMedia,
      onDragBeginHook,
      onOpenTagMenu,
      onOpenFilterMenu,
      saveMetaField,
      onShowDetailedView,
      onCloseDetailedView,
      modifierKeyDown,
      modifierKeyUp,
      onEscapeDown,
      loadMediaWithFetchId,
      toggleEditableTags,
      toggleSharedTagsView,
      searchMedia,
      onFilesDropped,
      onUploadNext,
      onDeleteSelectedFiles,
      askDeleteFiles,
      onScaleDetailedImage,
      onDeleteFileInDetailedView,
      onOverridePreview,
      onUploadPreviewProgress,
      onMouseUp,
      showUploadPanel,
      deleteFromUploadQueue,
      setActiveGroup,
      changeFormValue,
      togglePillClicked,
      setCurrentDetailedFile,
      onBlurPill,
      onFocusPill,
      showFileContextMenu,
      hideFileContextMenu,
      refetchMetadata
    }
  }
})



// WEBPACK FOOTER //
// ./src/modules/Media/index.js